import { __awaiter, __generator, __values } from 'tslib';
import { HttpParams } from '@angular/common/http';
import { S2AHttpClient } from '@s2a/ng-common';
import { Injectable, NgModule, defineInjectable, inject } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var IncidentsService = /** @class */ (function () {
    function IncidentsService(http) {
        this.http = http;
    }
    /**
     * @param {?=} searchString
     * @return {?}
     */
    IncidentsService.prototype.getScenarios = /**
     * @param {?=} searchString
     * @return {?}
     */
    function (searchString) {
        return __awaiter(this, void 0, void 0, function () {
            var options, httpParams, result, scenarios;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {};
                        httpParams = new HttpParams();
                        if (searchString) {
                            httpParams = httpParams.set('searchString', searchString);
                        }
                        options.params = httpParams;
                        return [4 /*yield*/, this.http.get('questionnaire/scenarios', options).toPromise()];
                    case 1:
                        result = _a.sent();
                        scenarios = result.scenarios.sort(function (a, b) {
                            return a.title.localeCompare(b.title);
                        });
                        return [2 /*return*/, Promise.resolve(scenarios)];
                }
            });
        });
    };
    /**
     * @param {?} scenarioId
     * @return {?}
     */
    IncidentsService.prototype.getScenario = /**
     * @param {?} scenarioId
     * @return {?}
     */
    function (scenarioId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('questionnaire/scenarios/' + scenarioId).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result.scenario)];
                }
            });
        });
    };
    /**
     * @param {?} scenario
     * @return {?}
     */
    IncidentsService.prototype.addScenario = /**
     * @param {?} scenario
     * @return {?}
     */
    function (scenario) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.post('questionnaire/scenarios', scenario).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    /**
     * @param {?} scenario
     * @return {?}
     */
    IncidentsService.prototype.updateScenario = /**
     * @param {?} scenario
     * @return {?}
     */
    function (scenario) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.put('questionnaire/scenarios/' + scenario.scenarioId, scenario).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    /**
     * @param {?} scenario
     * @return {?}
     */
    IncidentsService.prototype.deleteScenario = /**
     * @param {?} scenario
     * @return {?}
     */
    function (scenario) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.delete('questionnaire/scenarios/' + scenario.scenarioId).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    /**
     * @param {?} equipments
     * @return {?}
     */
    IncidentsService.prototype.prepareEquipments = /**
     * @param {?} equipments
     * @return {?}
     */
    function (equipments) {
        return equipments
            .map(function (e) {
            e.description = e.description ? e.description : e.techDesc;
            return e;
        })
            .sort(function (a, b) {
            return a.description.localeCompare(b.description);
        });
    };
    /**
     * @return {?}
     */
    IncidentsService.prototype.getOperatorLines = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('questionnaire/equipments/lines').toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(this.prepareEquipments(result.equipments))];
                }
            });
        });
    };
    /**
     * @param {?} lineId
     * @return {?}
     */
    IncidentsService.prototype.getOperatorMachines = /**
     * @param {?} lineId
     * @return {?}
     */
    function (lineId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('questionnaire/equipments/lines/' + lineId + '/machines').toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(/** @type {?} */ (this.prepareEquipments(result.equipments)))];
                }
            });
        });
    };
    /**
     * @param {?} machineId
     * @return {?}
     */
    IncidentsService.prototype.getOperatorComponents = /**
     * @param {?} machineId
     * @return {?}
     */
    function (machineId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('questionnaire/equipments/machines/' + machineId + '/components').toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(/** @type {?} */ (this.prepareEquipments(result.equipments)))];
                }
            });
        });
    };
    /**
     * @param {?=} machineType
     * @param {?=} componentType
     * @return {?}
     */
    IncidentsService.prototype.getMatchingScenarios = /**
     * @param {?=} machineType
     * @param {?=} componentType
     * @return {?}
     */
    function (machineType, componentType) {
        return __awaiter(this, void 0, void 0, function () {
            var options, httpParams, result, scenarios;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {};
                        httpParams = new HttpParams();
                        if (machineType) {
                            httpParams = httpParams.set('machineType', machineType);
                        }
                        if (componentType) {
                            httpParams = httpParams.set('componentType', componentType);
                        }
                        options.params = httpParams;
                        return [4 /*yield*/, this.http.get('questionnaire/scenarios', options).toPromise()];
                    case 1:
                        result = _a.sent();
                        scenarios = result.scenarios.sort(function (a, b) {
                            return a.title.localeCompare(b.title);
                        });
                        return [2 /*return*/, Promise.resolve(scenarios)];
                }
            });
        });
    };
    /**
     * @param {?} incident
     * @return {?}
     */
    IncidentsService.prototype.createIncident = /**
     * @param {?} incident
     * @return {?}
     */
    function (incident) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.post('questionnaire/incidents', incident).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    /**
     * @param {?} incidentId
     * @return {?}
     */
    IncidentsService.prototype.getIncident = /**
     * @param {?} incidentId
     * @return {?}
     */
    function (incidentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('questionnaire/incidents/' + incidentId).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result.incident)];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    IncidentsService.prototype.getIncidentCategories = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('questionnaire/incidents/categories').toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result.categories)];
                }
            });
        });
    };
    /**
     * @param {?} equipmentId
     * @return {?}
     */
    IncidentsService.prototype.getEquipment = /**
     * @param {?} equipmentId
     * @return {?}
     */
    function (equipmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('questionnaire/equipments/' + equipmentId).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result.equipments[0])];
                }
            });
        });
    };
    /**
     * @param {?} incidents
     * @return {?}
     */
    IncidentsService.prototype.prepareIncidents = /**
     * @param {?} incidents
     * @return {?}
     */
    function (incidents) {
        return incidents
            .filter(function (i) { return i.incidentId !== undefined; })
            .map(function (e) {
            e.equipmentName = e.equipmentName ? e.equipmentName : e.techDesc;
            e.iconUrl = e.iconUrl || (e.machine ? e.machine.iconUrl : '');
            return e;
        })
            .sort(function (a, b) {
            // sort by dateOfOccurence, newest first
            return (new Date(b.dateOfOccurence)).getTime() - (new Date(a.dateOfOccurence)).getTime();
        });
    };
    /**
     * @param {?=} from
     * @param {?=} to
     * @param {?=} searchString
     * @return {?}
     */
    IncidentsService.prototype.getUserIncidents = /**
     * @param {?=} from
     * @param {?=} to
     * @param {?=} searchString
     * @return {?}
     */
    function (from, to, searchString) {
        return __awaiter(this, void 0, void 0, function () {
            var params, options, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new HttpParams();
                        if (from) {
                            params = params.set('from', from);
                        }
                        if (to) {
                            params = params.set('to', to);
                        }
                        if (searchString) {
                            params = params.set('searchString', searchString);
                        }
                        options = {
                            params: params
                        };
                        return [4 /*yield*/, this.http.get('questionnaire/report/user', options).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.prepareIncidents(result.incidents)];
                }
            });
        });
    };
    /**
     * @param {?} from
     * @param {?} to
     * @param {?} searchString
     * @param {?=} number
     * @param {?=} lastId
     * @return {?}
     */
    IncidentsService.prototype.getAccountIncidents = /**
     * @param {?} from
     * @param {?} to
     * @param {?} searchString
     * @param {?=} number
     * @param {?=} lastId
     * @return {?}
     */
    function (from, to, searchString, number, lastId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, options, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new HttpParams();
                        if (from) {
                            params = params.set('from', from);
                        }
                        if (to) {
                            params = params.set('to', to);
                        }
                        if (searchString) {
                            params = params.set('searchString', searchString);
                        }
                        if (number) {
                            params = params.set('number', number.toString());
                        }
                        if (lastId) {
                            params = params.set('lastId', lastId);
                        }
                        options = {
                            params: params
                        };
                        return [4 /*yield*/, this.http.get('questionnaire/report/account', options).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.prepareIncidents(result.incidents)];
                }
            });
        });
    };
    /**
     * @param {?} from
     * @param {?} to
     * @param {?} searchString
     * @param {?=} number
     * @param {?=} lastId
     * @return {?}
     */
    IncidentsService.prototype.getLinesIncidents = /**
     * @param {?} from
     * @param {?} to
     * @param {?} searchString
     * @param {?=} number
     * @param {?=} lastId
     * @return {?}
     */
    function (from, to, searchString, number, lastId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, options, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new HttpParams();
                        if (from) {
                            params = params.set('from', from);
                        }
                        if (to) {
                            params = params.set('to', to);
                        }
                        if (searchString) {
                            params = params.set('searchString', searchString);
                        }
                        if (number) {
                            params = params.set('number', number.toString());
                        }
                        if (lastId) {
                            params = params.set('lastId', lastId);
                        }
                        options = {
                            params: params
                        };
                        return [4 /*yield*/, this.http.get('questionnaire/report/lines', options).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.prepareIncidents(result.incidents)];
                }
            });
        });
    };
    /**
     * @param {?} date
     * @return {?}
     */
    IncidentsService.prototype.getUserIncidentsForDate = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return __awaiter(this, void 0, void 0, function () {
            var params, options, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new HttpParams();
                        options = {
                            params: params.append('date', date)
                        };
                        return [4 /*yield*/, this.http.get('questionnaire/report/user', options).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.prepareIncidents(result.incidents)];
                }
            });
        });
    };
    /**
     * @param {?} date
     * @return {?}
     */
    IncidentsService.prototype.getAccountIncidentsForDate = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return __awaiter(this, void 0, void 0, function () {
            var params, options, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new HttpParams();
                        options = {
                            params: params.append('date', date)
                        };
                        return [4 /*yield*/, this.http.get('questionnaire/report/account', options).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.prepareIncidents(result.incidents)];
                }
            });
        });
    };
    /**
     * @param {?=} from
     * @param {?=} to
     * @param {?=} searchString
     * @return {?}
     */
    IncidentsService.prototype.getStatistics = /**
     * @param {?=} from
     * @param {?=} to
     * @param {?=} searchString
     * @return {?}
     */
    function (from, to, searchString) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, _a, e_2, _b, e_3, _c, params, options, result, sortedResult, sortedResult_1, sortedResult_1_1, line, _d, _e, equipment, _loop_1, _f, _g, inc;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        params = new HttpParams();
                        if (from) {
                            params = params.set('from', from);
                        }
                        if (to) {
                            params = params.set('to', to);
                        }
                        if (searchString) {
                            params = params.set('searchString', searchString);
                        }
                        options = {
                            params: params
                        };
                        return [4 /*yield*/, this.http.get('questionnaire/report/lines/tree', options).toPromise()];
                    case 1:
                        result = _h.sent();
                        sortedResult = result
                            .map(function (e) {
                            e.description = e.description ? e.description : e.techDesc;
                            return e;
                        })
                            .sort(function (a, b) {
                            return a.description.localeCompare(b.description);
                        });
                        try {
                            for (sortedResult_1 = __values(sortedResult), sortedResult_1_1 = sortedResult_1.next(); !sortedResult_1_1.done; sortedResult_1_1 = sortedResult_1.next()) {
                                line = sortedResult_1_1.value;
                                try {
                                    for (_d = __values(line.children), _e = _d.next(); !_e.done; _e = _d.next()) {
                                        equipment = _e.value;
                                        equipment.description = equipment.description ? equipment.description : equipment.techDesc;
                                        equipment.sumary = [];
                                        _loop_1 = function (inc) {
                                            /** @type {?} */
                                            var scenario = null;
                                            if (inc.scenario.scenarioId) {
                                                if (equipment.sumary.filter(function (s) { return s.scenarioId === inc.scenario.scenarioId; }).length > 0) {
                                                    scenario = equipment.sumary.filter(function (s) { return s.scenarioId === inc.scenario.scenarioId; })[0];
                                                    scenario.numIncidents += 1;
                                                }
                                                else {
                                                    scenario = {
                                                        scenarioId: inc.scenario.scenarioId,
                                                        description: inc.scenario.description,
                                                        title: inc.scenario.title,
                                                        numIncidents: 1
                                                    };
                                                    equipment.sumary.push(scenario);
                                                }
                                            }
                                            else {
                                                /** @type {?} */
                                                var scState_1 = '' + inc.scenarioStatus;
                                                if (!scState_1) {
                                                    scState_1 = 'NULL';
                                                }
                                                if (equipment.sumary.filter(function (s) { return s.scenarioId === scState_1; }).length > 0) {
                                                    scenario = equipment.sumary.filter(function (s) { return s.scenarioId === scState_1; })[0];
                                                    scenario.numIncidents += 1;
                                                }
                                                else {
                                                    scenario = {
                                                        scenarioId: scState_1,
                                                        description: scState_1,
                                                        title: scState_1,
                                                        numIncidents: 1
                                                    };
                                                    equipment.sumary.push(scenario);
                                                }
                                            }
                                        };
                                        try {
                                            for (_f = __values(equipment.incidents), _g = _f.next(); !_g.done; _g = _f.next()) {
                                                inc = _g.value;
                                                _loop_1(inc);
                                            }
                                        }
                                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                        finally {
                                            try {
                                                if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                                            }
                                            finally { if (e_3) throw e_3.error; }
                                        }
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (sortedResult_1_1 && !sortedResult_1_1.done && (_a = sortedResult_1.return)) _a.call(sortedResult_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/, sortedResult];
                }
            });
        });
    };
    /**
     * @param {?} incident
     * @return {?}
     */
    IncidentsService.prototype.updateIncident = /**
     * @param {?} incident
     * @return {?}
     */
    function (incident) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.put('questionnaire/incidents/' + incident.incidentId, incident).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    IncidentsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    IncidentsService.ctorParameters = function () { return [
        { type: S2AHttpClient }
    ]; };
    /** @nocollapse */ IncidentsService.ngInjectableDef = defineInjectable({ factory: function IncidentsService_Factory() { return new IncidentsService(inject(S2AHttpClient)); }, token: IncidentsService, providedIn: "root" });
    return IncidentsService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var NgIncidentsModule = /** @class */ (function () {
    function NgIncidentsModule() {
    }
    /**
     * @return {?}
     */
    NgIncidentsModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: NgIncidentsModule,
            providers: [
                IncidentsService,
            ]
        };
    };
    NgIncidentsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [],
                    exports: []
                },] }
    ];
    return NgIncidentsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { IncidentsService, NgIncidentsModule };

//# sourceMappingURL=s2a-ng-incidents.js.map